import { useToggleState } from "../../../../packages/hooks";
import { Context } from "./context";
import type { ProviderProps } from "./types";

export const DropzoneProvider = ({ children }: ProviderProps) => {
  const {
    toggle: isFileLimitExceeded,
    toggleOn: exceedFileLimit,
    toggleOff: resetFileLimitExceeded,
  } = useToggleState();

  return (
    <Context.Provider
      value={{
        isFileLimitExceeded,
        exceedFileLimit,
        resetFileLimitExceeded,
      }}
    >
      {children}
    </Context.Provider>
  );
};
